import React from "react";
import {
  FeatureDiscoveryCard,
  FeatureDiscoveryCards,
  FeatureDiscoveryHelpContainer,
  FeatureDiscoveryHelpTitle,
  FeatureDiscoveryNewBadge,
} from "./FeatureDiscoveryHelpEntries.styles";
import { useFeatureDiscovery } from "./FeatureDiscoveryProvider";
import {
  featureDiscoveryTours,
  newFeatureDiscoveryTourKey,
} from "./tourRegistry";

export const FeatureDiscoveryHelpEntries = (): React.ReactElement | null => {
  const { isTourAvailable, openTour } = useFeatureDiscovery();
  const availableTours = featureDiscoveryTours.filter((tour) =>
    isTourAvailable(tour.featureKey),
  );

  if (availableTours.length === 0) return null;

  return (
    <FeatureDiscoveryHelpContainer>
      <FeatureDiscoveryHelpTitle>New Features</FeatureDiscoveryHelpTitle>
      <FeatureDiscoveryCards>
        {availableTours.map((tour) => (
          <FeatureDiscoveryCard
            key={tour.featureKey}
            type="button"
            onClick={() => openTour(tour.featureKey, "help")}
          >
            <span>{tour.helpTitle}</span>
            {tour.featureKey === newFeatureDiscoveryTourKey && (
              <FeatureDiscoveryNewBadge>
                {tour.badgeLabel}
              </FeatureDiscoveryNewBadge>
            )}
          </FeatureDiscoveryCard>
        ))}
      </FeatureDiscoveryCards>
    </FeatureDiscoveryHelpContainer>
  );
};
